import { Wizard } from './Wizard'

const Settings = () => {

  return (
  <Wizard />
  )
}

export {Settings}
